import { Box, Typography } from '@mui/material';
import { yellow } from '@mui/material/colors';

import ApartmentIcon from '@mui/icons-material/Apartment';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SchoolIcon from '@mui/icons-material/School';
import ThreePIcon from '@mui/icons-material/ThreeP';

import { createStars } from 'utils/schoolUtils';

export default function TestimoniesRatingComponent({ rating }) {
  const ratingLabels = [
    {
      icon: <SchoolIcon sx={{ color: 'text.secondary', mr: 1 }} />,
      label: 'Escola',
      rating: rating?.schoolRating,
    },
    {
      icon: <ApartmentIcon sx={{ color: 'text.secondary', mr: 1 }} />,
      label: 'Infraestrutura',
      rating: rating?.infrastructureRating,
    },
    {
      icon: <MenuBookIcon sx={{ color: 'text.secondary', mr: 1 }} />,
      label: 'Curso',
      rating: rating?.courseRating,
    },
    {
      icon: <ThreePIcon sx={{ color: 'text.secondary', mr: 1 }} />,
      label: 'Metodologia',
      rating: rating?.teachingMethodologyRating,
    },
  ];

  return (
    <Box display="flex" flexDirection="column">
      {ratingLabels.map((item) => (
        <Box
          alignItems="center"
          display="flex"
          justifyContent="space-between"
          key={item.label}
          py={1}
        >
          <Typography alignItems="center" display="flex">
            {item.icon} {item.label}
          </Typography>

          <Box>{createStars(item?.rating, yellow[800], 'small')}</Box>
        </Box>
      ))}
    </Box>
  );
}
